import { InputSummaryItem } from '../../../../input-summary';
import InputSummaryUtils from '../../../../../helper/input-summary/input-summary-util';
import { UnitValue } from '../../../../data-structures/unit-value.model';

/**
 * An interface used to define the class structure for the feedstock bmp potential direct model
 */
export interface FeedstockBmpPotentialDirectInterface {
  bmp: UnitValue;
  ch4Concentration: UnitValue;
  period: UnitValue;
}

/**
 * A class that contains members for the feedstock BMP potential direct model
 */
export class FeedstockBmpPotentialDirect {
  bmp: UnitValue;
  ch4Concentration: UnitValue;
  period: UnitValue;

  /**
   * constructs the FeedstockBmpPotentialDirect class.
   * @param param is used to construct the class. If null or not provided, the class will be set to default values
   */
  constructor(param: FeedstockBmpPotentialDirectInterface = {
    bmp: new UnitValue({value: null, unit: '000000000000000000000606'}),
    ch4Concentration: new UnitValue(),
    period: new UnitValue({value: null, unit: '000000000000000000001302'}),
  }) {
    this.bmp = new UnitValue(param.bmp);
    this.ch4Concentration = new UnitValue(param.ch4Concentration);
    this.period = new UnitValue(param.period);
  }

  /**
   * returns a separate instance of the provided FeedstockBmpPotentialDirect obj
   * @param feedstockBmpPotentialDirect will be returned as a separate instance
   */
  static deepCopy(feedstockBmpPotentialDirect: FeedstockBmpPotentialDirect) {
    let copy;
    if (feedstockBmpPotentialDirect) {
      copy = new FeedstockBmpPotentialDirect(feedstockBmpPotentialDirect);
      return copy;
    }
    throw new Error('unable to perform deep copy of FeedstockBmpPotentialDirect');
  }

  /**
   * Returns an array of InputSummaryItem containing inputs for each member of the FeedstockBmpPotentialDirect class
   */
  getSummaryInputs(path: string[]) {
    let inputs: InputSummaryItem[] = [];
    inputs = InputSummaryUtils.performPush(inputs, FeedstockBmpPotentialDirectPropName.bmp, this.bmp, [...path, 'bmp']);
    inputs = InputSummaryUtils.performPush(inputs, FeedstockBmpPotentialDirectPropName.period, this.period, [...path, 'period']);
    inputs = InputSummaryUtils.performPush(inputs, FeedstockBmpPotentialDirectPropName.ch4Concentration, this.ch4Concentration, [...path, 'ch4Concentration']);
    return inputs;
  }
}

/**
 * An enum that contains a proper display name for properties of the FeedstockBmpPotentialDirect class.
 *
 * ALL MEMBERS ARE INTENTIONALLY CAMELCASE FOR OBJ REFERENCING
 */
export enum FeedstockBmpPotentialDirectPropName {
  bmp = 'INPUT_SUMMARY.FEEDSTOCK.BMP_POTENTIAL.BMP_DIRECT.BMP',
  ch4Concentration = 'INPUT_SUMMARY.FEEDSTOCK.BMP_POTENTIAL.CH4_CONCENTRATION',
  period = 'INPUT_SUMMARY.FEEDSTOCK.BMP_POTENTIAL.PERIOD',
  id_bmp = 'biomethane potential (BMP)',
  id_ch4Concentration = 'CH₄ concentration',
  id_period = 'period'
}
